// extracted by mini-css-extract-plugin
export default {"wrapper":"FC-z","viewport":"GC-z","container":"HC-z","slide":"IC-z"};